/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ContentViewTestScores from "../components/ContentViewTestScores";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { Link, useLocation } from "react-router-dom";
import { blue, red, yellow } from "@mui/material/colors";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PersonIcon from "@mui/icons-material/Person";
import Footer from "../components/Footer";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import IconButton from "@mui/material/IconButton";
import { useSelector } from "react-redux";
import Axios from "axios";
import moment from "moment";
import { logout } from "../../src/store/userSilce";
import { useDispatch } from "react-redux";
require("moment/locale/th");

const theme = createTheme({
  palette: {
    primary: {
      main: red[500],
    },
    secondary: {
      main: yellow[500],
    },
    third: {
      main: blue[800],
    },
  },
});

function PageTestScores() {
  const location = useLocation();
  const test1 = location.state;
  const { user } = useSelector((state) => state.user);
  const token = user.token;
  const userRole = user.userRole;
  const USR01 = userRole[0]?.status;
  const USR02 = userRole[1]?.status;
  const USR03 = userRole[2]?.status;
  const USR04 = userRole[3]?.status;
  const USR05 = userRole[4]?.status;
  const orgname = user.orgname;

  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [loading, setLoading] = useState(true);


  const previousMonth = () => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(newMonth.getMonth() - 1);
    setCurrentMonth(newMonth);
  };

  const nextMonth = () => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(newMonth.getMonth() + 1);
    setCurrentMonth(newMonth);
  };

  const monthsInThai = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];

  const buddhistEra = currentMonth.getFullYear() + 543;
  // console.log("monthsInThai",currentMonth.getMonth())
  // console.log("buddhistEra",buddhistEra)
  var months = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];
  const [allscores, setallscores] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [PreviousMonthCount, setPreviousMonthCount] = useState(
    new Date().getMonth() - 1
  );
  const [NextMonthCount, setNextMonthCount] = useState(
    new Date().getMonth() + 1
  );
  const [currentMonthCount, setCurrentMonthCount] = useState(
    new Date().getMonth()
  ); //monthcurrent
  const [currentYear, setcurrentYear] = useState(
    new Date().getFullYear() + 543
  ); //yearcurrent
  const [nextyear, setnextyear] = useState(
    months[NextMonthCount] === "มกราคม" ? currentYear + 1 : currentYear
  );
  const [Previousyear, setPreviousyear] = useState(
    months[PreviousMonthCount] === "ธันวาคม" ? currentYear - 1 : currentYear
  );
 



  const newData = allscores.map((item) => {
    // แยกปีและเดือนออกจากข้อมูลในฟิลด์ tbtestreservation.testreqdate
    const parts = item["tbtestreservation.testreqdate"].split("-");
    const year = parts[0];
    let month = parts[1];

    // ตรวจสอบว่าหากเดือนมี 0 นำหน้าให้ลบออก
    if (month.startsWith("0")) {
      month = month.substring(1); // เอาอักขระแรกออก
    }

    // สร้าง object ใหม่โดยรวมเฉพาะข้อมูลที่ต้องการ
    const newItem = {
      testreqdate: `${year}-${month}`,
    };

    return { ...item, ...newItem }; // รวมข้อมูลเดิมกับข้อมูลใหม่แล้วคืนค่า
  });
  const ChristianityYear = buddhistEra - 543;
  const YearAndMonth =
    ChristianityYear.toString() +
    "-" +
    (currentMonth.getMonth() + 1).toString();


  const filteredData = newData.filter((item) => {
    return item.testreqdate === YearAndMonth;
  });

 

  useEffect(() => {
    var config = {
      method: "GET",
      url:
        process.env.REACT_APP_API_URL +
        `/getalldataTestscores/${currentMonth.getMonth()}/${buddhistEra}`,
      headers: {
        authtoken: "bearer " + token,
      },
    };

    Axios(config)
      .then((res) => {
        setTimeout(() => {
        setallscores(res.data);

        setLoading(false); // เมื่อโหลดข้อมูลเสร็จให้เปลี่ยนสถานะ
      }, 2000); // จำลองการโหลดข้อมูล 2 วินาที
        // console.log("data :", res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: err.response.status, txt: err.response.data },
          });
        } else if (err.response.status === 404) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: err.response.status, txt: err.response.data },
          });
        }
        console.log("getPubrelContents: ", err);
      });
  }, [currentMonth.getMonth(), buddhistEra]);

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));



  const columns = [
    {
      field: "id",
      headerName: "ลำดับ",
      headerAlign: "center",
      width: 50,
      align: "center",
      valueGetter: (params) =>
        params.api.getRowIndex(params.row.testresvcode) + 1,
    },
    {
      field: "tbtestreservation.testrequnit",
      headerName: "หน่วยงาน",
      headerAlign: "center",
      width: 150,
      align: "center",
    },
    {
      field: "tbtestreservation.testappvcode",
      headerName: "รหัสการทดสอบ",
      headerAlign: "center",
      width: 200,
      align: "center",
    },
    {
      field: "testresvcode",
      headerName: "รหัสการจอง",
      headerAlign: "center",
      width: 250,
      align: "center",
    },
    {
      field: "tbtestreservation.testreqdate",
      headerName: "วันที่จอง",
      headerAlign: "center",
      width: 250,
      align: "center",
      renderCell: (params) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {moment(params.value).add(543, "year").format("ll")}
          </div>
        );
      },
    },
    {
      field: "tbtestreservation.testreqtime",
      headerName: "เวลาที่จอง",
      headerAlign: "center",
      width: 250,
      align: "center",
    },
    {
      field: "management",
      headerName: "การจัดการ",
      headerAlign: "center",
      width: 250,
      align: "center",
      renderCell: (params) => {
      

        return (
          <strong>
            <ThemeProvider theme={theme}>
              <Link
                to="/ContentPageTestScores"
                style={{ textDecoration: "none" }}
                state={{
                  testresultcode: params.row["testresultcode"],
                  testresvcode: params.row.testresvcode,
                  testreqdate: params.row["tbtestreservation.testreqdate"],
                  testreqtime: params.row["tbtestreservation.testreqtime"],
                  currentMonthCount: currentMonthCount,
                  currentYear: currentYear,
                  PreviousMonthCount: PreviousMonthCount,
                  Previousyear: Previousyear,
                  NextMonthCount: NextMonthCount,
                  nextyear: nextyear,
                }}
              >
                <Button
                  variant="outlined"
                  color="third"
                  size="small"
                  style={{ marginLeft: 16 }}
                 
                >
                  เข้าดูรายชื่อ
                </Button>
              </Link>
              {params.row.testresultapprv === null ? (
                <FiberNewIcon className="New_Tag"></FiberNewIcon>
              ) : (
                ""
              )}
            </ThemeProvider>
          </strong>
        );
      },
    },
  ];




  return (
    <>
      <br></br>

      <Typography component="div">
        <Box sx={{ textAlign: "center", fontSize: 35, fontWeight: 500 }}>
          <b>ข้อมูลผลคะแนนการทดสอบ</b>
        </Box>
      </Typography>
      <DrawerHeader />

      <Box
        sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IconButton aria-label="delete" size="large" onClick={previousMonth}>
            <ChevronLeftIcon />
          </IconButton>
          <Typography variant="subtitle1" gutterBottom>
            {monthsInThai[currentMonth.getMonth() - 1] === undefined
              ? "ธันวาคม"
              : monthsInThai[currentMonth.getMonth() - 1]}{" "}
            {buddhistEra}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle1" gutterBottom>
            {monthsInThai[currentMonth.getMonth() + 1] === undefined
              ? "มกราคม"
              : monthsInThai[currentMonth.getMonth() + 1]}{" "}
            {buddhistEra}
          </Typography>
          <IconButton aria-label="delete" size="large" onClick={nextMonth}>
            <NavigateNextIcon />
          </IconButton>
        </Box>
      </Box>
      <br></br>
      <div style={{ height: 400, width: "100%" }}>
        <Box sx={{ display: "flex" }}>
          <Link
            to="/ContentListScores"
            style={{ textDecoration: "none", padding: "2px" }}
          >
            <Button variant="outlined" startIcon={<PersonIcon />}>
              ดูผลคะแนนตามรายการทดสอบ
            </Button>
          </Link>

          <Link
            to="/ContentListDivisionScores"
            style={{ textDecoration: "none", padding: "2px" }}
          >
            <Button variant="outlined" startIcon={<PersonIcon />}>
              ดูผลคะแนนตามหน่วยงาน
            </Button>
          </Link>
          <Link
            to="/ContentIndividualScores"
            style={{ textDecoration: "none", padding: "2px" }}
          >
            <Button variant="outlined" startIcon={<PersonIcon />}>
              ดูผลคะแนนรายบุคคล
            </Button>
          </Link>
        </Box>
        <br></br>

        <DataGrid
          getRowId={(row) => row.testresvcode}
       
          rows={filteredData}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          initialState={{
            filter: {
              filterModel: {
                items: [],
                quickFilterLogicOperator: GridLinkOperator.Or,
              },
            },
          }}
          loading={loading}
        />
      </div>
      <DrawerHeader />
    </>
  );
}

export default PageTestScores;
